// getProject — returns the project only if the caller can access it (org member or
// SuperAdmin; null otherwise, per the membership-gated resolver). Source of truth for
// both the router guard (project-access validation) and the active-project context
// (project name + ownership), so org users get a populated project without any
// per-project TeamMember row.
export default `
  query getProject($projectId: String!) {
    getProject(projectId: $projectId) {
      id
      name
      organisationId
      organisation {
        id
        userId
        name
      }
    }
  }
`
